import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useState } from "react";
import api from "../../../Apis";
import { useCookies } from "react-cookie";
import Swal from "sweetalert2";

export const BusinesseManagement = () => {
  const [is_open_dialog, setIsOpenDialog] = useState(false)
  const [businesse_id, setBusinesseId] = useState('');
  const [businesse_name, setBusinesseName] = useState('');
  const [cookies, setCookie] = useCookies('is_login');
  const [data, setData] = useState([]);

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + cookies.is_login
      }
    };
    fetch(api.businesse_management_list, requestOptions)
    .then(res => res.json())
    .then(
      (result) => {
        if (result.success) {
          setData(result.data)
        }
      }
    )
  }, []);

  console.log(businesse_name);

  return (
    <Container maxWidth="xl" className='m-t-40'>
      <Dialog
        open={is_open_dialog} fullWidth="true" maxWidth='sm' onClose={() => setIsOpenDialog(false)}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const businesse_name = formJson.businesse_name;
            const requestOptions = {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + cookies.is_login
              },
              body: JSON.stringify({
                businesse_name: businesse_name,
                businesse_id: businesse_id
              })
            };
            fetch(api.businesse_management_update, requestOptions)
            .then(res => res.json())
            .then(
              (result) => {
                Swal.fire(result.message, "", result.success ? "success" : "error")
              }
            )
            console.log(businesse_name);
            setIsOpenDialog(false);
          }}
        >
          <DialogTitle>Sửa tài khoản doanh nghiệp</DialogTitle>
          <DialogContent>
            <TextField defaultValue={businesse_name} margin="dense" required id="outlined-basic" name="businesse_name" label="Tên doanh nghiệp" autoFocus fullWidth={true} size="small" variant="outlined" />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="inherit" onClick={() => setIsOpenDialog(false)}>Đóng</Button>
            <Button variant="contained" type="submit">
              Xác nhận
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>Tên doanh nghiệp</TableCell>
                    <TableCell>Hành động</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                {
                  data.map((data_item, index) => {
                    return (
                      <TableRow>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{data_item.id}</TableCell>
                        <TableCell>{data_item.name}</TableCell>
                        <TableCell>
                          <EditIcon onClick={() => {
                            setIsOpenDialog(true)
                            setBusinesseId(data_item.id)
                            setBusinesseName(data_item.name)
                          }} className="cursor-pointer" />
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Container>
  )
}